import { useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";
import { allowedTabs } from "../constants/permissionCatalog";
import UsersChat from "../pages/dashboardPage/customerService/usersChat/UsersChat";
import PrizeDelivery from "../pages/dashboardPage/customerService/prizeDelivery/PrizeDelivery";

const PrimeChats = () => <UsersChat plan="prime" />;

// Tab id (permissionCatalog "customer-support") → its page.
const TAB_PAGES = {
  "users-chat": UsersChat,
  "prime-chats": PrimeChats,
  "prize-delivery": PrizeDelivery,
};

const CustomerServiceNavigator = () => {
  const { rolePermissions } = useSelector((state) => state.user);
  const tabs = allowedTabs("customer-support", rolePermissions);
  const FirstTab = tabs[0] ? TAB_PAGES[tabs[0].id] : null;

  return (
    <Routes>
      {tabs.map((tab) => {
        const Page = TAB_PAGES[tab.id];
        return <Route key={tab.id} path={`/${tab.path}`} element={<Page />} />;
      })}
      {FirstTab && <Route path="*" element={<FirstTab />} />}
    </Routes>
  );
};

export default CustomerServiceNavigator;
